import { render } from "./OneProductSloganComponent.vue?vue&type=template&id=95bbf952&scoped=true"
import script from "./OneProductSloganComponent.vue?vue&type=script&lang=js"
export * from "./OneProductSloganComponent.vue?vue&type=script&lang=js"

import "./OneProductSloganComponent.vue?vue&type=style&index=0&id=95bbf952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95bbf952"]])

export default __exports__